import { getFullName } from '@/helpers/string';
import { useGetAllCompanyUsers } from '@/hooks/data/masterDataHook';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {
  role: string;
}
export default function CompanyUserInput({ role, ...props }: Props) {
  const { data, isLoading } = useGetAllCompanyUsers(role);

  return (
    <Select
      loading={isLoading}
      maxTagCount="responsive"
      allowClear
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data?.map(c => {
        return (
          <Select.Option key={c.id} value={c.userId}>
            {getFullName(c.firstName, c.lastName)}
          </Select.Option>
        );
      })}
    </Select>
  );
}
